import { QuickLinks } from './quick-links';
import { FieldViewModel } from 'src/app/models/field/field-layout-view-model.model';
import { LayoutQuickLink } from './layout-quick-link';
import { FieldLayoutViewModelService } from '../../../services/field-layout-view-model.service';

export class LayoutQuickLinks extends QuickLinks {

  constructor(private flvms: FieldLayoutViewModelService) {
    super();
  }

  /** Creates a new field layout on the server and adds it to recent layouts. */
  addNew(fields: FieldViewModel[]) {
    this.flvms.createFieldLayout(fields).subscribe(created => this.addRecent(new LayoutQuickLink(created)));
  }

  initialize() {
    this.flvms.getLayouts().subscribe(layouts => {
      if (!layouts) return;
      super.set(layouts.map(l => new LayoutQuickLink(l)));
    });
  }

  getSharedAndPinnedDeepCopy(): LayoutQuickLink[] {
    return this.sharedAndPinned.map(ql => new LayoutQuickLink((<LayoutQuickLink>ql).getLayout()));
  }

  getRecentDeepCopy(): LayoutQuickLink[] {
    return this.recent.map(ql => new LayoutQuickLink((<LayoutQuickLink>ql).getLayout()));
  }
}
